module.exports = __webpack_public_path__ + "static/media/hourglass_blue_full02781ecdc4bfe5a9529bb8d5591cc216.webp";